// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/ooc_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournamentContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tournamentContainer p {
  color: #fff;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 12px */
}

.tournamentCardWraper {
  display: flex;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  transition: all ease-in-out 0.5s;
}

.tournamentCardWraper:hover{
  transform: scale(1.02);
  cursor: pointer;
}

.tournamentCardWraper img {
  width: 100%;
  height: 100px;
  object-fit: contain;
}
.tournamentCardWraper .tournamentInfos h1 {
  color: #fff;
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 900;
  line-height: 100%; /* 12px */
  text-transform: uppercase;
}

.tournamentInfosPlus {
  display: flex;
  padding: 24px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 6px;
  background: rgba(24, 48, 81, 0.25);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
}

.tournamentInfosPlus ul {
  list-style: none;
  display: flex;
  justify-content: space-around;
  width: 100%;
}

.tournamentInfosPlus ul li {
  color: #ccc;
  text-align: center;
  font-family: Lato;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 8px */
  text-transform: capitalize;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.placesRestantes {
  display: flex;
  height: 48px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 39px;
  background: #c3d32c;
  font-size: 16px;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 1.82px;
  color: white;
  width: 80%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Accueil/TournamentCard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,aAAa;EACb;2CACuC;EACvC,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,QAAQ;EAC3B,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,UAAU;AACZ","sourcesContent":[".tournamentContainer {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.tournamentContainer p {\r\n  color: #fff;\r\n  font-family: Lato;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 100%; /* 12px */\r\n}\r\n\r\n.tournamentCardWraper {\r\n  display: flex;\r\n  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),\r\n    url(\"../../assets/Images/ooc_bg.png\");\r\n  background-size: cover;\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  border-radius: 12px;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 12px;\r\n  transition: all ease-in-out 0.5s;\r\n}\r\n\r\n.tournamentCardWraper:hover{\r\n  transform: scale(1.02);\r\n  cursor: pointer;\r\n}\r\n\r\n.tournamentCardWraper img {\r\n  width: 100%;\r\n  height: 100px;\r\n  object-fit: contain;\r\n}\r\n.tournamentCardWraper .tournamentInfos h1 {\r\n  color: #fff;\r\n  text-align: center;\r\n  font-family: Montserrat;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  line-height: 100%; /* 12px */\r\n  text-transform: uppercase;\r\n}\r\n\r\n.tournamentInfosPlus {\r\n  display: flex;\r\n  padding: 24px 12px;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 12px;\r\n  align-self: stretch;\r\n  border-radius: 6px;\r\n  background: rgba(24, 48, 81, 0.25);\r\n  backdrop-filter: blur(15px);\r\n}\r\n\r\n.tournamentInfosPlus ul {\r\n  list-style: none;\r\n  display: flex;\r\n  justify-content: space-around;\r\n  width: 100%;\r\n}\r\n\r\n.tournamentInfosPlus ul li {\r\n  color: #ccc;\r\n  text-align: center;\r\n  font-family: Lato;\r\n  font-size: 0.8rem;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 100%; /* 8px */\r\n  text-transform: capitalize;\r\n  text-align: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.placesRestantes {\r\n  display: flex;\r\n  height: 48px;\r\n  padding: 0px 12px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 4px;\r\n  flex-shrink: 0;\r\n  border-radius: 39px;\r\n  background: #c3d32c;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  line-height: 21px;\r\n  letter-spacing: 1.82px;\r\n  color: white;\r\n  width: 80%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
